<template>
  <div class="cf-flex cf-flex--column cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      {{ giftingPointsContent.title }}
    </Teleport>

    <!-- Transfer Points Form -->
    <cf-validated-form
      v-if="!showConfirmation"
      key="cn12"
      name="giftingPointsForm"
      data-test-id="gifting-points-form-wrapper"
      @valid-submit="submitGiftingPointsForm()"
    >
      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <p
          data-test-id="gifting-points-description-display"
          class="cf-subtitle cf-subtitle--2"
        >
          {{ giftingPointsContent.description }}
        </p>

        <!-- Gift Points Amount Input -->
        <cf-text-input
          v-model="pointsToGift"
          v-auto-focus
          data-test-id="gifting-points-amount-input-field"
          type="number"
          :label="pointsInputLabel"
          :icon-class="'fa-gift'"
          name="giftingPointsReceipient"
          class="half-spacing"
          :validations="{
            required: true,
          }"
        />

        <!-- Min & Max Requirements -->
        <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-center cf-flex--gap-16">
          <p
            data-test-id="gifting-points-min-allowed-display"
            :class="['cf-subtitle cf-subtitle--2', { 'cf-subtitle--red': calculations.belowMin, 'cf-subtitle--heavy': calculations.belowMin }]"
          >
            Minimum: {{ numberDisplay(calculations.minGiftingPointRestriction) }}
          </p>

          <span class="gray">|</span>

          <p
            data-test-id="gifting-points-max-allowed-display"
            :class="['cf-subtitle cf-subtitle--2', { 'cf-subtitle--red': calculations.exceedsMax, 'cf-subtitle--heavy': calculations.exceedsMax }]"
          >
            Maximum: {{ numberDisplay(calculations.maxGiftingPointRestriction) }}
          </p>
        </div>

        <!-- Remaining Points Display -->
        <h3
          data-test-id="gifting-points-remaining-points-display"
          class="cf-title cf-title--3"
        >
          You have <span class="cf-title--brand-primary"> {{ remainingRewardsPoints }} </span> remaining.
        </h3>

        <cf-title-separator :omit-title="true" />

        <h4 class="cf-title cf-title--4 cf-text-align-left">
          Send to:
        </h4>

        <!-- Gift Receipient Email Input -->
        <cf-text-input
          id="recipient-email-input"
          v-model="recipientEmail"
          data-test-id="gifting-points-gift-to-input-field"
          type="email"
          label="Email Address"
          name="recipientEmail"
          icon-class="fa-envelope"
          :validations="{
            required: true,
          }"
        />

        <!-- Error Banner -->
        <div
          v-if="hasInsufficientFunds"
          data-test-id="gifting-points-error-banner"
          class="notifications__message notifications__message--danger half-spacing"
        >
          {{ giftingPointsContent.error }}
        </div>

        <!-- Submit button -->
        <button
          :disabled="isInvalidForm"
          type="submit"
          data-test-id="gifting-points-form-submit-button"
          class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        >
          {{ giftingPointsContent.cta }}
        </button>
      </div>
    </cf-validated-form>

    <!-- Confirmation Form -->
    <cf-validated-form
      v-if="showConfirmation"
      key="cn1"
      name="giftingPointsForm"
      data-test-id="confirm-points-form-wrapper"
      @valid-submit="submitConfirmation()"
    >
      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <div
          data-test-id="confirm-points-description-display"
          class="cf-title cf-title--1"
        >
          {{ pointsConfirmationContent.description }}
        </div>

        <p
          data-test-id="confirm-points-sub-description-display"
          class="cf-subtitle cf-subtitle--2"
        >
          {{ pointsConfirmationContent.subDescription }}
        </p>

        <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-center cf-flex--gap-12">
          <div class="rounded-points-container">
            <h2
              data-test-id="confirm-points-total-gifting-points-display"
              class="cf-title cf-title--2 cf-title--brand-primary"
            >
              {{ pointsToGift }}
            </h2>

            <h6
              data-test-id="confirm-points-currency-display"
              class="cf-title cf-title--6"
            >
              {{ loyalty.currency.pluralShortNameUpperCase }}
            </h6>
          </div>

          <span class="cf-icon fa-arrow-right" />

          <div class="receipient-container">
            <p
              data-test-id="confirm-points-recipient-email-display"
              class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy"
            >
              {{ recipientEmail }}
            </p>
          </div>
        </div>

        <!-- Potential Column Layout -->
        <!-- <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--justify-center cf-flex--gap-12">
          <div class="rounded-points-container">
            <h2
              data-test-id="confirm-points-total-gifting-points-display"
              class="cf-title cf-title--2 cf-title--brand-primary"
            >
              {{ pointsToGift }}
            </h2>

            <h6
              data-test-id="confirm-points-currency-display"
              class="cf-title cf-title--6"
            >
              {{ loyalty.currency.pluralShortNameUpperCase }}
            </h6>
          </div>

          <span class="cf-icon fa-arrow-down" />

          <div class="receipient-container">
            <p
              data-test-id="confirm-points-recipient-email-display"
              class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy"
            >
              {{ recipientEmail }}
            </p>
          </div>
        </div> -->

        <!-- Remaining Points Display -->
        <h3
          data-test-id="confirm-points-remaining-points-display"
          class="cf-title cf-title--3"
        >
          You have <span class="cf-title--brand-primary"> {{ remainingRewardsPoints }} </span> remaining.
        </h3>

        <button
          data-test-id="confirm-points-form-submit-button"
          type="submit"
          class="cf-button cf-button--secondary cf-button--lg cf-button--fill"
          @click="adjustGiftingPointsClickHandler"
        >
          Adjust Gifted Points
        </button>

        <button
          data-test-id="confirm-points-form-submit-button"
          type="submit"
          :class="['cf-button cf-button--primary cf-button--lg cf-button--fill', { 'cf-button--loading': isSubmittingGiftedPoints }]"
        >
          {{ pointsConfirmationContent.cta }}
        </button>
      </div>
    </cf-validated-form>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import numberDisplay from '@/helpers/number-display';

  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';
  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';


  export default {
    name: 'GiftLoyaltyPoints',

    components: {
      CfValidatedForm,
      CfTextInput,
      CfTitleSeparator
    },

    inject: {
      $validator: {
        from: '$validator'
      },

      validatedForm: {
        from: 'validatedForm',
        default() {
          return {};
        }
      }
    },

    data() {
      return {
        pointsToGift: null,
        recipientEmail: null,
        disabled: true,
        showConfirmation: false,
        isSubmittingGiftedPoints: false
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('offers', ['loyalty']),

      pointsInputLabel() {
        return `${this.loyalty.currency.pluralNameCapitalCase} to gift`;
      },

      giftingPointsContent() {
        const content = this.content.PointGiftingModal;

        return {
          title: content.title,
          description: content.description,
          cta: content.metadata.cta,
          error: content.metadata.error
        };
      },

      pointsConfirmationContent() {
        const content = this.content.PointGiftingConfirmationModal;

        return {
          description: content.title,
          subDescription: content.description,
          cta: content.metadata.cta
        };
      },

      hasUserPointsInput() {
        return true;
      },

      currentPointBalance() {
        return this.loyalty.currentBalance;
      },

      calculations() {
        const subtractedTotal = this.currentPointBalance - this.pointsToGift;

        const minGiftingPointRestriction = this.loyalty.primaryLedger.currency.pointGiftPolicy.minPointsPerGift || 1;

        const maxGiftingPointRestriction = Math.min(this.currentPointBalance, 100000);

        return {
          minGiftingPointRestriction,
          maxGiftingPointRestriction,
          belowMin: this.pointsToGift < minGiftingPointRestriction,
          exceedsMax: this.pointsToGift > maxGiftingPointRestriction,
          subtractedTotal
        };
      },

      hasInsufficientFunds() {
        return this.calculations.subtractedTotal < 0;
      },

      remainingRewardsPoints() {
        const pointsToGift = this.calculations.subtractedTotal > 0 ? this.calculations.subtractedTotal : 0;

        return `${numberDisplay(pointsToGift)} ${this.loyalty.currency.pluralName}`;
      },

      isInvalidForm() {
        return !this.recipientEmail
          || this.calculations.belowMin
          || this.calculations.exceedsMax
          || this.hasInsufficientFunds;
      }
    },

    created() {
      this.pointsToGift = this.calculations.minGiftingPointRestriction;
    },

    methods: {
      numberDisplay,

      submitGiftingPointsForm() {
        this.showConfirmation = true;
      },

      adjustGiftingPointsClickHandler() {
        this.showConfirmation = false;
      },

      async submitConfirmation() {
        const dispatchPayload = {
          numberOfPoints: this.pointsToGift,
          recipientEmailAddress: this.recipientEmail,
          currencyPublicId: this.loyalty.primaryLedger.currencyPublicId
        };

        this.isSubmittingGiftedPoints = true;

        await this.$store.dispatch('offers/sendGiftedLoyaltyPoints', dispatchPayload);

        await this.$store.dispatch('offers/getOffers', { silentError: true });

        this.$closeModal('giftingPointsModal');
      }
    }
  };
</script>


<style lang="sass">
.rounded-points-container
  padding-top: 5px
  border-radius: 1000px
  border: solid 1px var(--color-light-gray)
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  width: 55px
  height: 55px

.receipient-container
  border: 1px solid #D8D8D8
  border-radius: 100px
  padding: 12px
</style>

